import CnpjUtils from "../../shared/utils/CnpjUtils";

function montarMensagemReprovado(cnpj) {
  const cnpjFormatado = CnpjUtils.formatAlphanumericCnpj(cnpj || "");
  return `Cliente <strong>${cnpjFormatado}</strong> bloqueado (status reprovado).<br>Favor entrar em contato com o time <a href="mailto:duvidas@essilorpromo.com.br"><strong>duvidas@essilorpromo.com.br</strong></a>`;
}

async function getUserLoginData(email) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      email: email,
    }),
  };

  try {
    const response = await fetch(process.env.REACT_APP_LABS_API + "OEC/usuario/get_user_login_validation.php", requestOptions);
    if (!response.ok) {
      throw new Error(`Erro HTTP: ${response.status}`);
    }
    const json = await response.json();
    return json;
  } catch (error) {
    console.error("Erro ao buscar dados do usuário: ", error);
    return { success: false, conta: null, contaProvisoria: null };
  }
}

async function getEmpresaStatus(cnpj) {
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      cnpj: cnpj,
    }),
  };

  try {
    const response = await fetch(process.env.REACT_APP_LABS_API + "OEC/empresa/get_empresa_status.php", requestOptions);
    if (!response.ok) {
      throw new Error(`Erro HTTP: ${response.status}`);
    }
    const json = await response.json();
    return json;
  } catch (error) {
    console.error("Erro ao buscar status da empresa: ", error);
    return { success: false, status: null };
  }
}

async function checkReferencial(cnpj) {
  const cnpjLimpo = cnpj ? cnpj.replace(/[.\-\/]/g, '') : '';
  
  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      access_token: sessionStorage.getItem("token"),
      idcliente: cnpjLimpo,
    }),
  };

  try {
    const response = await fetch(process.env.REACT_APP_LABS_API + "sensidia/gestao_clientes/get_clientes_referencial.php", requestOptions);
    if (!response.ok) {
      return { found: false };
    }
    const json = await response.json();
    return { found: true, data: json };
  } catch (error) {
    console.error("Erro ao verificar Referencial: ", error);
    return { found: false };
  }
}

export async function validateLoginCompany(email) {
  const userData = await getUserLoginData(email);
  
  if (!userData.success) {
    return { 
      canLogin: true, 
      message: null 
    };
  }

  const conta = userData.conta;
  const contaProvisoria = userData.contaProvisoria;

  if (!conta || conta === '' || conta === null) {
    if (!contaProvisoria || contaProvisoria === '' || contaProvisoria === null) {
      return { 
        canLogin: true, 
        message: null 
      };
    } else {
      const empresaStatus = await getEmpresaStatus(contaProvisoria);
      
      if (!empresaStatus.success) {
        return { 
          canLogin: false, 
          message: "O cadastro da sua empresa está aguardando aprovação." 
        };
      }

      const status = empresaStatus.status;
      
      if (status === "PENDENTE APROVAÇÃO" || status === "Pendente Aprovação" || status === "pendente_aprovacao") {
        return { 
          canLogin: false, 
          message: "O cadastro da sua empresa está aguardando aprovação." 
        };
      } else if (status === "REPROVADO" || status === "Reprovado" || status === "reprovado") {
        return {
          canLogin: false,
          message: montarMensagemReprovado(contaProvisoria)
        };
      } else {
        return { 
          canLogin: true, 
          message: null 
        };
      }
    }
  } else {
    const referencialCheck = await checkReferencial(conta);
    
    if (referencialCheck.found) {
      return { 
        canLogin: true, 
        message: null 
      };
    } else {
      return { 
        canLogin: false, 
        message: "O cadastro da sua empresa está aguardando aprovação." 
      };
    }
  }
}

export { getUserLoginData, getEmpresaStatus, checkReferencial, montarMensagemReprovado };
